import "scripts/templates/page.videos.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.videos");
